import { createFileRoute } from '@tanstack/react-router'

import { HiddenOnTrial } from '@/modules/account'
import { GettingStartedPage } from '@/modules/getting-started'

export const Route = createFileRoute('/_authenticated/getting-started')({
  staticData: { title: 'Getting started' },
  component: GettingStarted,
})

function GettingStarted() {
  return (
    <HiddenOnTrial>
      <GettingStartedPage />
    </HiddenOnTrial>
  )
}
